export const TERMINALS_REQUEST = 'REPORT/TERMINALS/REQUEST';
export const TERMINALS_SUCCESS = 'REPORT/TERMINALS/SUCCESS';
export const TERMINALS_FAILURE = 'REPORT/TERMINALS/FAILURE';
export const SEARCH_REQUEST = 'REPORT/SEARCH/REQUEST';
export const SEARCH_SUCCESS = 'REPORT/SEARCH/SUCCESS';
export const SEARCH_FAILURE = 'REPORT/SEARCH/FAILURE';
export const SEARCH_CLEAR = 'REPORT/SEARCH/CLEAR';
export const SET_TERMINALS = 'REPORT/TERMINALS/SET';
export const SET_REPORT = 'REPORT/TYPE/SET';
export const SET_CHIP = 'REPORT/CHIP/SET';
export const SET_DATE = 'REPORT/DATE/SET';
export const CLEAR = 'REPORT/CLEAR';
export const CLEAR_HIDEABLE = 'REPORT/CLEAR/HIDEABLE';
